import { defineComponent as p, ref as m } from "vue";
import y from "./index164.js";
import I from "./index166.js";
import { HeaderNavLevel as v, buildTrackingData as S } from "./index570.js";
import w from "./index580.js";
import { MsArrow as B, MsClose as E, MsArrowLeft as A } from "@sunrise/icons";
import C from "./index40.js";
import { screenSizeDetection as H, commonUtils as O } from "@sunrise/shared";
import { getLoginLink as s } from "./index569.js";
import { trackLink as T } from "@sunrise/tracking";
const G = p({
  name: "MsOffcanvasNav",
  components: {
    MsArrowLeft: A,
    MsClose: E,
    MsArrow: B,
    MsHeaderBookmark: y,
    MsHeaderLogin: I,
    CsSecondaryButton: C,
    ChannelIconHomeSvg: w
  },
  props: {
    isOpen: { default: !1, type: Boolean },
    header: {
      type: Object,
      required: !0
    }
  },
  emits: ["close"],
  setup(n, { emit: d }) {
    const a = m(!1), t = m(null), { isScreenL: i } = H();
    n.header.navigationId && (t.value = c(n.header.navigationId), t.value && (a.value = !0));
    function g(e) {
      return !i.value && n.header.headerMeta.bookmarkEnabled && e === n.header.channelLabel;
    }
    function h(e) {
      return !i.value && s(n.header) && e === n.header.channelLabel;
    }
    function L(e) {
      e.target === e.currentTarget && l();
    }
    function k(e) {
      var o;
      return ((o = t.value) == null ? void 0 : o.navigationId) === e && a.value;
    }
    function N() {
      a.value && u();
    }
    function l() {
      d("close");
    }
    function u(e) {
      a.value = !a.value, e && (t.value = c(e));
    }
    function c(e) {
      return n.header.navigations.find((r) => r.navigationId === e) || null;
    }
    function b(e, o, r, f) {
      const M = S(e, o, n.header.channelName, r);
      return T(f, f.currentTarget, M);
    }
    return {
      clickAnywhere: L,
      isSubNavOpen: a,
      closeLayer: N,
      closeNav: l,
      getRel: O.getRel,
      linkTracking: b,
      toggleSubNav: u,
      isActive: k,
      isScreenL: i,
      showBookmarks: g,
      getLoginLink: s,
      showLoginLink: h,
      level1: v.LEVEL1,
      level2: v.LEVEL2
    };
  }
});
export {
  G as default
};
